module.exports = __webpack_public_path__ + "img/cabinet_PearlGold.318c1e17.png";